import { render, staticRenderFns } from "./TooltipOnHover.vue?vue&type=template&id=298b5ac1"
import script from "./TooltipOnHover.vue?vue&type=script&lang=js"
export * from "./TooltipOnHover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports